import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';
import type { IFastGalleryDefinition } from '../documentManagement/FastGallery.definition';
import type { FastGalleryPreviewMapperProps } from '../FastGallery.types';
import { props as viewerPropsMapper } from './FastGallery.mapper';

const props = composeMapper<
  FastGalleryPreviewMapperProps,
  IFastGalleryDefinition
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState', 'componentViewMode'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState, componentViewMode } = deps;

    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);
    const previewState: string | null =
      componentViewMode === 'editor' ? compPreviewState : null;
    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
      compPreviewState: previewState,
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
